module.exports = __webpack_public_path__ + "img/icon-about-us-white.36d902e1.svg";